import { createSelector } from 'reselect';

const selectnetworks = (state: any) => state.networks;


export const selectnetworksCurrentItem = createSelector([selectnetworks], (networks) => networks.current);

export const selectnetworksListItems = createSelector([selectnetworks], (networks) => networks.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectnetworksListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectnetworksQueryItems = createSelector([selectnetworks], (networks) => networks.query);

export const selectnetworksCreatedItem = createSelector([selectnetworks], (networks) => networks.create);

export const selectnetworksUpdatedItem = createSelector([selectnetworks], (networks) => networks.update);

export const selectnetworksReadItem = createSelector([selectnetworks], (networks) => networks.read);

export const selectnetworksDeletedItem = createSelector([selectnetworks], (networks) => networks.delete);

export const selectnetworksSearchedItems = createSelector([selectnetworks], (networks) => networks.search);

export const selectnetworksItemsCount = createSelector([selectnetworks], (networks) => networks.count);

export const selectnetworksItemsFilter = createSelector([selectnetworks], (networks) => networks.filter);